var exports = {
  "B8": "List__Ku5Rqm",
  "vu": "Chip__X0M5S_",
  "L5": "ChipPreview__snXipX",
  "ts": "ChipThumb__hYSOax",
  "RN": "ChipLabel__So-5E_",
  "dX": "ChipRemove__GLypls",
};

module.exports = exports;
